import { useSearchParams } from 'react-router-dom';
import { SourceIds } from 'enums/SourceIds';

export const useReinstatementCheck = () => {
  const [searchParams] = useSearchParams();
  const sourceId = searchParams.get('SourceID');
  const isReinstatement = sourceId === SourceIds.Reinstatement;

  return { isReinstatement };
};
